import { dataHomeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHomeSolid = /*#__PURE__*/createIcon(dataHomeSolid)
export default IconHomeSolid
